



































import mixins from 'vue-typed-mixins';
import SurveyUtils, { Survey } from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';
import ProviderUtils, { ServiceProviderType } from '@/utils/ProviderUtils';
import OversightUtils, {
  OversightOrganization,
  OversightOrganizationType,
} from '@/utils/OversightUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Survey,
    },
  },
  computed: {
    providerOptions(): any {
      return this.providerTypes?.map((type) => ({
        text: this.$translate(type.name),
        value: type.id,
      }));
    },
    oversightOptions(): any {
      return this.oversights?.map((oversight) => ({
        text: this.$translate(oversight.name),
        value: oversight.id,
      }));
    },
  },
  data(): {
    providerTypes?: ServiceProviderType[];
    oversights?: OversightOrganization[];
  } {
    return {
      providerTypes: undefined,
      oversights: undefined,
    };
  },
  async mounted() {
    try {
      if (!this.value.filter) {
        this.value.filter = {};
        this.$emit('pristine', this.value);
      }

      const resp: any = await Promise.all([
        ProviderUtils.api.type.list(),
        OversightUtils.api.instance.list(),
      ]);
      this.providerTypes = resp[0];
      this.oversights = resp[1];
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async save() {
      try {
        this.$alert.hide('save');
        await SurveyUtils.api.survey.update(this.value);
        this.$emit('pristine', this.value);
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.default', {
            values: [this.$languageobj('model.survey.label')],
          }),
        });
      } catch (error) {
        this.$alert.show('save', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
  },
});
